import { useEffect, useRef } from 'react';

interface SEOMetaProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogType?: string;
  ogImage?: string;
  ogTitle?: string;
  ogDescription?: string;
  twitterCard?: string;
  schema?: Record<string, unknown>[];
}

export default function SEOMeta({
  title,
  description,
  keywords,
  canonicalUrl,
  ogType = 'website',
  ogImage,
  ogTitle,
  ogDescription,
  twitterCard = 'summary_large_image',
  schema,
}: SEOMetaProps) {
  const fullTitle = `${title} - 黑料吃瓜`;
  const siteUrl = 'https://heiliao-chigua.com';
  const scriptRefs = useRef<HTMLScriptElement[]>([]);

  useEffect(() => {
    document.title = fullTitle;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    if (keywords) setMeta('keywords', keywords);

    const canonicalEl = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (canonicalEl) {
      canonicalEl.setAttribute('href', canonicalUrl || `${siteUrl}${window.location.pathname}`);
    } else {
      const link = document.createElement('link');
      link.rel = 'canonical';
      link.href = canonicalUrl || `${siteUrl}${window.location.pathname}`;
      document.head.appendChild(link);
    }

    setMeta('og:type', ogType, true);
    setMeta('og:title', ogTitle || fullTitle, true);
    setMeta('og:description', ogDescription || description, true);
    setMeta('og:url', canonicalUrl || `${siteUrl}${window.location.pathname}`, true);
    setMeta('og:site_name', '黑料吃瓜', true);
    setMeta('og:locale', 'zh_CN', true);
    if (ogImage) setMeta('og:image', ogImage, true);

    setMeta('twitter:card', twitterCard);
    setMeta('twitter:title', ogTitle || fullTitle);
    setMeta('twitter:description', ogDescription || description);
    if (ogImage) setMeta('twitter:image', ogImage);

    if (schema) {
      schema.forEach((item, index) => {
        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.textContent = JSON.stringify(item);
        document.head.appendChild(script);
        scriptRefs.current.push(script);
      });
    }

    return () => {
      scriptRefs.current.forEach((s) => {
        if (s.parentNode) s.parentNode.removeChild(s);
      });
      scriptRefs.current = [];
    };
  }, [fullTitle, description, keywords, canonicalUrl, ogType, ogImage, ogTitle, ogDescription, twitterCard, schema, siteUrl]);

  return null;
}